import { memo } from 'react';
import Box from '@mui/material/Box';
// Local files
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import PenStudyFlow from 'components/Flows/PenStudyFlows/PenStudyFlows';
import PenStudyAnalysisDrawer from 'components/Analyses/PenStudyAnalyses/Drawer/Drawer';

const PenStudyFlows = () => {

  return (
    <Box sx={{ flexGrow: 1, display: 'flex', overflow: 'hidden'  }}>
      <PenStudyAnalysisDrawer />
      <PenStudyFlow />
    </Box>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <PenStudyFlows {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);